export type WorkspaceTab = 'home' | 'assignments' | 'schedule' | 'resources' | 'members';
export type ScheduleMode = 'list' | 'calendar';

export const WORKSPACE_TABS: readonly WorkspaceTab[] = ['home', 'assignments', 'schedule', 'resources', 'members'];

export const VISUAL_APP_ROUTE_SCREENS = [
  'auth-email',
  'auth-login',
  'auth-register',
  'auth-forgot-password',
  'onboarding-choice',
  'onboarding-create-choir',
  'onboarding-join-code',
  'onboarding-join-nickname',
  'onboarding-join-submitted',
  'onboarding-choose-existing-choir',
  'workspace-home',
  'workspace-assignments',
  'workspace-schedule',
  'workspace-resources',
  'workspace-members',
  'notifications',
  'song-detail',
  'song-related-folder',
  'resource-preview',
  'schedule-detail',
  'schedule-create',
  'schedule-edit',
  'schedule-attendance-settings',
  'schedule-time-picker',
  'confirm-delete-schedule',
  'assignment-create',
  'assignment-detail',
  'assignment-upload',
  'choir-management',
  'approval-list',
  'approval-detail',
  'invitation-codes',
  'member-settings',
  'season-settings',
  'permission-groups',
  'create-permission-group',
  'permission-group-detail',
  'edit-permission-group',
  'confirm-delete-permission-group',
  'manage-permission-group-members',
  'confirm-remove-permission-group-member',
  'manage-member-groups',
  'create-member-group',
  'rename-member-group',
  'confirm-delete-member-group',
  'create-member-group-initial-member',
  'member-group-detail',
  'manage-member-group-members',
  'confirm-remove-member-group-member',
  'manage-member-group-tags',
  'confirm-delete-member-group-tag',
  'rename-member-group-tag',
  'create-member-group-tag',
  'member-group-tag-detail',
  'schedule-settings',
  'create-attendance-category',
  'rename-attendance-category',
  'confirm-disable-attendance-category'
] as const;

export type VisualAppRouteScreen = (typeof VISUAL_APP_ROUTE_SCREENS)[number];
